import axios from '../axios'

export function updateStatusNew(configOptions, type, params ) {



  let data = {
    //[type]: parseInt(this.$refs[type].value)
    [type]: params ? parseInt(params.orderStatus) :parseInt(this.$refs[type].value)
  };


  let msgContent = '';

  // old value
  let comperar = '';
  let optionKey = '';
  let noteName = '';
  switch (type) {
    case 'orderStatus':
      comperar = 'statusId';
      optionKey = 'statuses';
      noteName = 'סטטוס הזמנה'
      break;
    case 'lackOfClaimsStatus':
      comperar = 'lackOfClaimsStatus';
      optionKey = 'lackOfClaims';
      noteName = 'עבר ביטוחי';
      break;
    case 'paymentStatus':
      comperar = 'paymentStatus';
      optionKey = 'paymentStatus';
      noteName = 'גביה'
      break;
    case 'changesStatus':
      comperar = 'changesStatus';
      optionKey = 'changesStatus';
      noteName = 'שינויים'
      break;
    case 'claimsStatus':
      comperar = 'claimsStatus';
      optionKey = 'claimsStatus';
      noteName = 'תביעות'
      break;
    case 'policyStatus':
      comperar = 'policyStatus';
      optionKey = 'policyStatus';
      noteName = 'ביטול'
      break;
    case 'protectiveStatus':
      comperar = 'protectiveStatus';
      optionKey = 'protectionStatus';
      noteName = 'מיגון';
      break;
  }


  //translate old value
  for (let i in configOptions[optionKey]) {
    if (configOptions[optionKey][i].key == params['previewOrderList'][0]['rowInfo'][comperar]) {
      msgContent += configOptions[optionKey][i].value
    }
  }
  //translate new value
  for (let i in configOptions[optionKey]) {
    if (configOptions[optionKey][i].key == params[type]) {
      msgContent += ' > ' + configOptions[optionKey][i].value
    }
  }




  let sendParamsInfo = {
    'subject' : noteName,
    'description': msgContent,
    'previewOrderList' : params['previewOrderList'],
    data

  }


  //let rowId = baseInfo['rowInfo']['id'];

  //addNewNoteQuery(notInfo, rowId);

  axios.post(`/orders/updateMultipleStatus`, sendParamsInfo)
    .then((res) => {
      return true;
      //this.$emit('alert', 'success', 'Status updated')
      //this.appendData()
    }).catch((err) => {
    //this.$emit('alert', 'danger', err.response.data.data.error)
  })

}

export function checkWhatsappUser (phone, firstName, lastName) {
  if(!phone || !firstName || !lastName) {
    return;
  }
  let data = {
    phone: phone,
    firstName: firstName,
    lastName: lastName,
  };

  axios.post(`/whatsappCampaign/updateCustomerInfo`, data)
    .then((res) => {
      if(res.data.data.isOpenChat) {
        const redirect = res.data.data.redirect;
        const newUrl = `${redirect}${phone}`;

        window.open(newUrl, '_blank');
      }
    }).catch((err) => {
    console.log(err)
  }).finally(() => {

  })
}

export function splitName(name) {
  const parts = name.trim().split(/\s+/); // מפריד לפי רווחים

  if (parts.length === 0) {
    return { firstName: '', lastName: '' };
  }
  const firstName = parts[0];
  const lastName = parts.slice(1).join(' '); // כל השאר

  return [firstName, lastName]
}
